import React, { useEffect, useState } from 'react'
import { NavLink } from '../../../lib/Navigation';
import URI from 'urijs';
import { Link } from 'react-router-dom';
import Manager from '../Manager';
import "./css/css.css"

export default function HomeBanner(props) {

  const banner = props.banner
  
  const bannerDiv = (banner) => {
    return <div style={{position:'relative', borderRadius:'13px', overflow:'hidden'}}>
      {banner?.game_info && Object.keys(banner?.game_info)?.length > 0 && <div style={{position:'absolute',left:0,right:0,bottom:55,height:15,background:`linear-gradient(to top, ${banner.color}, transparent)`}}></div>}
      <img className = "banner-img" src={banner.img} alt="" />
      {banner?.game_info && Object.keys(banner?.game_info)?.length > 0 && <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'5px 15px 10px',backgroundColor:banner.color}}>
        <div>
          <div style={{fontSize:16,color:'white',fontWeight:500,lineHeight:'17px'}}>{banner.game_info.name}</div>
          <div style={{fontSize:12,color:'#DDDDDD',paddingTop:5}}>{banner.game_info.description}</div>
        </div>
        <img src={banner.game_info.image} alt="" height={15}/>
      </div>}
    </div>
  }

  return (
    <div className='index-home-banner' key={banner.id}>
      {banner.type === 'insideUrl' || banner.type === 'externalUrl' || banner.type == 'news' ?
        <NavLink user={banner.login} to={(() => {
          if (localStorage.getItem('username')){
            let url = URI(banner.val)
              .addQuery('username', localStorage.getItem('username'))
              .addQuery('token', localStorage.getItem('token'))
              .addQuery('mb', localStorage.getItem('mb'))
              .addQuery('location_url', window.location.origin)
              .addQuery('origin', 'react')
              .toString();
            return url;
          }else{
            let url = URI(banner.val)
              .addQuery('mb', localStorage.getItem('mb'))
              .addQuery('location_url', window.location.origin)
              .addQuery('origin', 'react')
              .toString();
            return url;
          }
        })()}
        onClick={()=>{
          Manager.push({ event_id:banner.event_id })
        }}
        iframe = {{title: banner.title}}
        >
          {bannerDiv(banner)}
        </NavLink>
      : 
      <Link
        to={(() => {
          if (banner.type === 'game') {
            return '/game?id=' + banner.val;
          }
          if (banner.type === 'special') {
            return '/game/project?id=' + banner.val;
          }
          if(banner.type == 'vouchandgift') {
            return '/giftproject'
          }
          if(banner.type == 'signgift') {
            return '/signgift'
          }
        })()}
        onClick={()=>{
          Manager.push({ event_id:banner.event_id })
        }}
      >
        {bannerDiv(banner)}
      </Link>}
    </div>
  )
}
